import * as Yup from 'yup'

import { EMPTY_LIST } from '../../../../constants/common'
import { getItemsIds } from '../../../../utils/common'
import { isFormArrayFieldsEqual } from '../../../../utils/formHelpers'
import {
  EntityActionTypeSelectOptionValue,
  getEntityActionTypeSelectOptions,
  isRemoveAllEntityActionType,
} from '../../../Entity'
import { formValidationSchemaNoChanged } from '../../../Form'
import { FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME } from '../../../Formik'
import { toUserSelectItem } from '../../../User'

import {
  BUILDING_EDIT_PROPERTY_OWNERS_FIELD_NAME_ALL_FLATS,
  BUILDING_EDIT_PROPERTY_OWNERS_FIELD_NAME_PROPERTY_OWNERS,
} from './BuildingsEditPropertyOwnersActionModal.constants'

export function getInitialValues({ itemAction, users }) {
  const actionTypeOptions = getEntityActionTypeSelectOptions()

  return {
    [BUILDING_EDIT_PROPERTY_OWNERS_FIELD_NAME_ALL_FLATS]: false,
    [BUILDING_EDIT_PROPERTY_OWNERS_FIELD_NAME_PROPERTY_OWNERS]:
      users?.map(toUserSelectItem) || EMPTY_LIST,
    [FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME]: itemAction
      ? actionTypeOptions[EntityActionTypeSelectOptionValue.Edit]
      : actionTypeOptions[EntityActionTypeSelectOptionValue.Add],
  }
}

export function getValidationSchema({ initialValues, itemAction }) {
  return Yup.object({
    [BUILDING_EDIT_PROPERTY_OWNERS_FIELD_NAME_PROPERTY_OWNERS]:
      Yup.array().when(FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME, {
        is: actionType =>
          !isRemoveAllEntityActionType(actionType) && !itemAction,
        then: schema => schema.of(Yup.object()).min(1, true),
      }),
  }).when(EMPTY_LIST, {
    is: () => itemAction,
    then: schema =>
      schema.concat(
        formValidationSchemaNoChanged({
          initialValues,
          isEqual: isFormArrayFieldsEqual,
          isEqualProps: {
            name: BUILDING_EDIT_PROPERTY_OWNERS_FIELD_NAME_PROPERTY_OWNERS,
          },
        })
      ),
  })
}

export function getPayload(values) {
  return {
    [BUILDING_EDIT_PROPERTY_OWNERS_FIELD_NAME_ALL_FLATS]:
      values[BUILDING_EDIT_PROPERTY_OWNERS_FIELD_NAME_ALL_FLATS],
    ids: getItemsIds(
      values[BUILDING_EDIT_PROPERTY_OWNERS_FIELD_NAME_PROPERTY_OWNERS],
      'value'
    ),
  }
}
